import { Valence } from '@upright/common/model/types';
import { SdgBoxesWithBarsForValence } from '@upright/ui/common/upright/core/impact-lenses/sdg/data-area/sdg-boxes-with-bars-for-valence';
import { SdgTitleForValence } from '@upright/ui/common/upright/core/impact-lenses/sdg/data-area/sdg-title-for-valence';

export function SdgBoxesWithBars() {
  return (
    <>
      <SdgTitleForValence valence={Valence.POSITIVE} />
      <SdgTitleForValence valence={Valence.NEGATIVE} />
      <SdgBoxesWithBarsForValence valence={Valence.POSITIVE} />
      <SdgBoxesWithBarsForValence valence={Valence.NEGATIVE} />
    </>
  );
}
